// ---- components/About.js ----
export function ERPAbout() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Enterprise Resouce Planning
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        a powerful, open-source enterprise resource planning (ERP) system
        designed to help businesses of all sizes manage their operations
        efficiently. Built on the Frappe framework, ERPNext offers a
        comprehensive suite of integrated modules covering accounting,
        inventory, sales, purchasing, manufacturing, human resources, and
        more—all within a single platform. Its intuitive interface and
        flexibility make it ideal for companies looking to streamline processes,
        improve collaboration, and gain real-time insights into their business
        performance. Whether you're a small startup or a growing enterprise,
        ERPNext provides the tools needed to automate workflows, reduce manual
        tasks, and scale operations seamlessly.
      </p>
    </section>
  );
}
